import { Component, OnInit } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { OkeeyCashCongratulationsModalComponent } from '../../shared/modal/okeey-cash-congratulations-modal/okeey-cash-congratulations-modal.component';
import { User } from 'shared/types/user.model';
import { AuthService } from 'core/services/auth.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GoBackComponent } from 'shared/components/go-back/go-back.component';
import { ThousandsSeparatorPipe } from 'shared/pipes/thousands-separator.pipe';
import { NgClass } from '@angular/common';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { KorviuButtonComponent } from 'shared/components/korviu-button/korviu-button.component';
import { RouterModule } from '@angular/router';
import { HideTooltipOnScrollDirective } from 'shared/directives';

@Component({
  selector: 'app-okeey-cash',
  templateUrl: './okeey-cash.component.html',
  styleUrl: './okeey-cash.component.scss',
  standalone: true,
  imports: [
    GoBackComponent,
    TranslateModule,
    ThousandsSeparatorPipe,
    NgClass,
    NzTooltipModule,
    HideTooltipOnScrollDirective,
    KorviuButtonComponent,
    RouterModule
  ]
})
export class OkeeyCashComponent implements OnInit {
  public headerCard: any[] = [
    {
      imgSrc: 'assets/img/my-okeey-cash/Profile_Picture_Desktop.svg',
      imgAlt: 'Profile Picture',
      textKey: 'okeeyCash.spending'
    },
    {
      imgSrc: 'assets/img/my-okeey-cash/earning.svg',
      imgAlt: 'Icons',
      textKey: 'okeeyCash.referral'
    }
  ];
  public sections = [
    {
      title: 'okeeyCash.startHere',
      items: [
        {
          imgSrc: 'assets/img/my-okeey-cash/application.svg',
          title: 'okeeyCash.application',
          description: 'okeeyCash.findOut',
          link: 'apply'
        },
        {
          imgSrc: 'assets/img/my-okeey-cash/whatNext.svg',
          title: 'okeeyCash.applied',
          description: 'okeeyCash.whatNext',
          link: 'journey'
        }
      ]
    },
    {
      title: 'okeeyCash.helpfulLink',
      items: [
        {
          imgSrc: 'assets/img/my-okeey-cash/account-benefit.svg',
          title: 'okeeyCash.accountBenefit',
          description: 'okeeyCash.discover',
          link: 'benefit'
        },
        {
          imgSrc: 'assets/img/my-okeey-cash/making-deposit.svg',
          title: 'okeeyCash.makingDeposits',
          description: 'okeeyCash.seeClosestLocation',
          link: 'deposit'
        }
      ]
    },
    {
      title: 'okeeyCash.promotionalBenefits',
      items: [
        {
          imgSrc: 'assets/img/my-okeey-cash/family-card.svg',
          title: 'okeeyCash.familyCardHealth.title',
          description: 'okeeyCash.familyCardHealth.description',
          link: 'family-health'
        },
        {
          imgSrc: 'assets/img/my-okeey-cash/unigana-eligibility.svg',
          title: 'okeeyCash.uniganaEligibility.title',
          description: 'okeeyCash.uniganaEligibility.description',
          link: 'eligibility'
        }
      ]
    },
    {
      title: 'okeeyCash.documentation',
      items: [
        {
          imgSrc: 'assets/img/my-okeey-cash/documentation.svg',
          title: 'okeeyCash.yourDocumentation',
          description: 'okeeyCash.viewCardHolder',
          link: 'documentation'
        },
        {
          imgSrc: 'assets/img/my-okeey-cash/employer-deposit.svg',
          title: 'okeeyCash.employerDeposit.title',
          description: 'okeeyCash.downloadDeposit',
          link: 'employer-deposit'
        }
      ]
    }
  ];

  public isEligible: boolean;
  public hasDepositedEnough: boolean;
  public hasReferredCustomer: boolean;
  public depositValue: number;
  public referralValue: number;
  public get currentUser(): User {
    return this._authService.currentUser;
  }
  public hasokeeyCashInternalUserId: boolean;

  constructor(
    private _modalService: NzModalService,
    private _authService: AuthService,
    private _translateService: TranslateService
  ) {
    this.depositValue = 0;
    this.referralValue = 0;
    this.isEligible = false;
    this.hasDepositedEnough = false;
    this.hasReferredCustomer = false;
    this.hasokeeyCashInternalUserId = false;
  }
  public ngOnInit(): void {
    this.checkEligibility();
  }
  public checkEligibility(): void {
    this.hasDepositedEnough = this.checkDepositAmount();
    this.hasReferredCustomer = this.checkReferralStatus();

    this.isEligible = this.currentUser.isEligible;
    this.hasokeeyCashInternalUserId = !!this.currentUser.okeeyCashInternalUserId;
  }

  private checkDepositAmount(): boolean {
    this.depositValue = this.currentUser.spentMoney;
    return this.depositValue >= 750;
  }

  private checkReferralStatus(): boolean {
    this.referralValue = this.currentUser.totalNetworkSize;
    return this.referralValue >= 1;
  }

  public okeeyCashSignIn(): void {
    const selectedLanguage: string = this._translateService.currentLang;
    window.open(`https://usa.okeeycash.com/${selectedLanguage}/login`, '_blank');
  }

  private _openSharOkeeyCashCongratulationModal(): void {
    this._modalService.create({
      nzContent: OkeeyCashCongratulationsModalComponent,
      nzData: { status },
      nzCentered: true,
      nzClosable: true,
      nzWidth: 554,
      nzWrapClassName: 'modal-wrap'
    });
  }
}
